import {
	GEPP_INSPECT_LOADING,
	GEPP_INSPECT_GET,
	GEPP_INSPECT_ERROR
} from '../actions/types';

const initialState = {
	gepp_inspection_loading: false,
	gepp_inspection: null,
	gepp_errors: {}
};

export default function geppReducer(state = initialState, action) {
	switch (action.type) {
		case GEPP_INSPECT_LOADING:
			return { ...state, gepp_inspection_loading: action.payload };

		case GEPP_INSPECT_GET:
			delete state.gepp_errors.gepp_inspect;
			return { ...state, gepp_inspection: action.payload };

		case GEPP_INSPECT_ERROR:
			return {
				...state,
				gepp_errors: {
					...state.gepp_errors,
					[action.payload.type]: { msg: action.payload.msg }
				}
			};

		default:
			return state;
	}
}
